import script from "./MenuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuButton.vue?vue&type=script&setup=true&lang=js"

import "./MenuButton.vue?vue&type=style&index=0&id=4a3b7a6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3b7a6c"]])

export default __exports__